import { BsArrowRight } from '@react-icons/all-files/bs/BsArrowRight';
import { Link } from 'gatsby';
import type { FC } from 'react';
import type { IndustriesEntity } from '../../../@types/gql/home';

const Card: FC<IndustriesEntity> = ({ Image, Title, Slug }) => {
  return (
    <div
      className="w-full h-full text-gray-50 relative flex items-end justify-center px-1.5"
      title={Title}
    >
      <div className="flex justify-between space-x-2 items-center mb-4 absolute w-10/12 z-10">
        <Link to={`/industries/workpiece-by-industry/${Slug}`}>
          <p className="font-bold text-2xl line-clamp-1">{Title}</p>
        </Link>
        <Link to={`/industries/workpiece-by-industry/${Slug}`}>
          <BsArrowRight className="font-bold text-2xl" />
        </Link>
      </div>
      <Link
        className="overflow-hidden"
        to={`/industries/workpiece-by-industry/${Slug}`}
      >
        <img
          alt="..."
          className="w-full min-h-72 aspect-video object-cover object-top rounded-md h_indus_img"
          loading="lazy"
          src={Image.url}
        />
      </Link>
    </div>
  );
};

export default Card;
